<template>
  <div class="headBackWrap">
    <div class="headerWrap">
      <i class="el-icon-back" @click="goPath"></i>
      <div class="title">{{ title }}</div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'HeadBack',
  props: {
    title: {
      type: String,
      required: true
    },
    routerPath: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    goPath() {
      if (this.routerPath) {
        try {
          this.$router.push(JSON.parse(this.routerPath))
        } catch (error) {
          this.$router.push(this.routerPath)
        }
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.headBackWrap{
  position: relative;
  height: 40px;
  z-index:999;
}
 .headerWrap{
        width: 100%;
        height: 40px;
        background: linear-gradient(180deg, #1F243C 0%, #323855 100%);
        position: fixed;
        /deep/.el-icon-back{
            position: absolute;
            left:40px;
            color:#fff;
            font-size:20px;
            top: 10px;
            cursor: pointer;
        }
        .title{
            font-size: 22px;
            font-family: PingFang HK-Semibold, PingFang HK;
            font-weight: 600;
            color: #FFFFFF;
            text-align: center;
            line-height: 40px;
        }
    }
    </style>
